import { render } from "./_addMediaRander.vue?vue&type=template&id=b06e904a&ts=true"
import script from "./_addMediaRander.vue?vue&type=script&lang=ts"
export * from "./_addMediaRander.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__